import { GetHestiaPredictionsResponse } from '@api/getHestiaPredictions'

import { CreditCardAlternativeProductsCategory } from '@appTypes/EligibilityApi.interface'

const getEligibleAltProductCategories = (
    categories: CreditCardAlternativeProductsCategory[],
    hestia?: GetHestiaPredictionsResponse
) => {
    return categories.filter(category => {
        if (
            category.id === 'Homeowner Loans' &&
            hestia?.predictions?.some(
                p => p.lender === 'MAIN_PANEL' && p.probability < 0.05
            )
        ) {
            return false
        }

        return true
    })
}

export default getEligibleAltProductCategories
